export function calculatePercentage(value: number, total: number): number {
  if (total === 0) return 0;

  const percent = (value / total) * 100;
  // Always round up to the nearest 0.01
  return Math.min(Math.ceil(percent * 100) / 100, 100);
}
